import * as React from 'react'

import {
  selectLegacyServiceLoading,
  useLegacyServiceLoadingStore,
} from '@/modules/shared/stores/legacyServiceLoadingStore'

/**
 * Wstrzykuje `isLoading` z `legacyServiceLoadingStore` do komponentu podłączonego
 * przez `connect`.
 *
 * Potrzebne, bo licznik spinnera starej warstwy przeniósł się z reduxowego slice'a
 * `service` do zustanda, a `mapStateToProps` przelicza się **wyłącznie** przy zmianie
 * stanu reduxa. Odczyt store.getState() wewnątrz `mapStateToProps` skompilowałby się
 * i dał poprawną wartość początkową, ale nigdy by się nie odświeżył — spinner
 * zapaliłby się raz i został.
 *
 * Przepuszcza ref dalej: panel administracyjny sięga po instancję zakładki.
 * Zwykły komponent funkcyjny zjadłby ten ref, a React zgłosiłby
 * "Function components cannot be given refs".
 */
export function withLoading<P extends { isLoading?: boolean }>(
  Wrapped: React.ComponentType<P>,
) {
  const WithLoading = React.forwardRef<unknown, Omit<P, 'isLoading'>>(
    (props, ref) => {
      const isLoading = useLegacyServiceLoadingStore(selectLegacyServiceLoading)
      return <Wrapped ref={ref as any} {...(props as unknown as P)} isLoading={isLoading} />
    },
  )

  WithLoading.displayName = `withLoading(${
    (Wrapped as any).displayName || (Wrapped as any).name || 'Component'
  })`

  return WithLoading
}
